import { SubmitOfferFormData } from 'src/components/offer/SectionOffer';
import { MyOffer } from 'src/entities/offer/MyOffer';
import { Offer } from 'src/entities/offer/Offer';
import { action } from 'src/store/actions';

/**
 * Edit offer
 */
export const EDIT_OFFER = 'EDIT_OFFER';

export const editOffer = (offer: Offer) => action(EDIT_OFFER, { offer });

/**
 * Submit offer
 */

export const UPDATE_OFFER = 'UPDATE_OFFER';
export const SUBMIT_OFFER = 'SUBMIT_OFFER';
export const SUBMIT_AND_PAY_OFFER = 'SUBMIT_AND_PAY_OFFER';
export const SUCCESS_SUBMIT_OFFER = 'SUCCESS_SUBMIT_OFFER';

export const updateOffer = (data: SubmitOfferFormData) => action(UPDATE_OFFER, { data });
export const submitOffer = (data: SubmitOfferFormData) => action(SUBMIT_OFFER, { data });
export const submitAndPayOffer = (data: SubmitOfferFormData) => action(SUBMIT_AND_PAY_OFFER, { data });
export const successSubmitOffer = () => action(SUCCESS_SUBMIT_OFFER, {});

/**
 * Apply offer
 */
export const APPLY_OFFER = 'APPLY_OFFER';
export const SUCCESS_APPLY_OFFER = 'SUCCESS_APPLY_OFFER';

export const applyOffer = (offer: MyOffer) => action(APPLY_OFFER, { offer });
export const successApplyOffer = () => action(SUCCESS_APPLY_OFFER, {});

/**
 * R65 item 1: the shop goods wait while an accepted offer occupies the cart
 */
export const PARK_CART = 'PARK_CART';
export const CLEAR_PARKED_CART = 'CLEAR_PARKED_CART';
export const RESTORE_PARKED_CART = 'RESTORE_PARKED_CART';

/** `cart` is the cart state's raw content; none when the cart was empty. */
export const parkCart = (offerPublicId: string, cart?: object) => action(PARK_CART, { offerPublicId, cart });
export const clearParkedCart = () => action(CLEAR_PARKED_CART);
export const restoreParkedCart = () => action(RESTORE_PARKED_CART);

/**
 * Fetch my offers
 */
export const FETCH_MY_OFFERS = 'FETCH_MY_OFFERS';
export const REQUEST_MY_OFFERS = 'REQUEST_MY_OFFERS';
export const REQUEST_MY_OFFERS_SUCCESS = 'REQUEST_MY_OFFERS_SUCCESS';
export const REQUEST_MY_OFFERS_FAILURE = 'REQUEST_MY_OFFERS_FAILURE';

export const fetchMyOffers = () => action(FETCH_MY_OFFERS);
export const requestMyOffers = () => action(REQUEST_MY_OFFERS);
export const requestMyOffersSuccess = (response: any) => action(REQUEST_MY_OFFERS_SUCCESS, { response });
export const requestMyOffersFailure = (error: any) => action(REQUEST_MY_OFFERS_FAILURE, { error });

export const CLEAR_MY_OFFERS = 'CLEAR_MY_OFFERS';
export const clearMyOffers = () => action(CLEAR_MY_OFFERS);

/**
 * Fetch offers
 */
export const FETCH_OFFERS = 'FETCH_OFFERS';
export const REQUEST_OFFERS = 'REQUEST_OFFERS';
export const REQUEST_OFFERS_SUCCESS = 'REQUEST_OFFERS_SUCCESS';
export const REQUEST_OFFERS_FAILURE = 'REQUEST_OFFERS_FAILURE';

export const fetchOffers = () => action(FETCH_OFFERS);
export const requestOffers = () => action(REQUEST_OFFERS);
export const requestOffersSuccess = (response: any) => action(REQUEST_OFFERS_SUCCESS, { response });
export const requestOffersFailure = (error: any) => action(REQUEST_OFFERS_FAILURE, { error });
